import { render, staticRenderFns } from "./ActivityValidation.vue?vue&type=template&id=7087c962&"
import script from "./ActivityValidation.vue?vue&type=script&lang=js&"
export * from "./ActivityValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports